<template>
  <div v-if="item">
    <h2>{{ item.type_display }}</h2>

    <fields-list :item="item" :fields="fields" />

    <button class="btn btn-warning btn-icon" @click="updateItem">
      <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
    </button>

    <div class="mt-5">
      <h4>Подразделы</h4>
      <lessonplan-lessonplans :id="id" />
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import LessonplanLessonplans from "./LessonplanLessonplans.vue";

export default {
  components: { LessonplanLessonplans },
  data: () => ({
    cardLink: "lessonplans",
    cardSetLink: "lessonplans",
    item: null,
    fields: [
      {
        col: "col-12 col-md-12",
        key: "name",
        label: "Название",
        type: "field",
        textType: "text",
      },

      {
        col: "col-12 col-md-7",
        label: "Автор",
        key: "author",
        type: "select",
        selectKey: "title",
        modal: "author",
        prefix: "author",
      },
      {
        col: "col-12 col-md-5",
        key: "position",
        label: "Номер",
        type: "field",
        textType: "number",
      },

      {
        label: "Предмет",
        key: "discipline",
        type: "select",
        selectKey: "title",
        modal: "discipline",
        prefix: "lessonplan_discipline",
      },
      {
        col: "col-12 col-md-6",
        key: "locale",
        label: "Локализация контента",
        type: "locale",
        textType: "text",
      },
      {
        col: "col-12 col-md-6",
        label: "Для классов",
        key: "course_id",
        type: "course",
        selectKey: "title",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
